<template>
  <div id="structure_ground_ship">
    <div v-if="receivedData">
      <SelectGraphic
        :receivedData="receivedData"
        id="structure_ground"
        graph-type="bar"
        index-axis="x"
      />
    </div>
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'StructureGround',
  components: {
    SelectGraphic: () => import('@/components/graph/SelectGraphic.vue'),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'structure_ground',
      cloneElementId: 'structure_ground_ship'
    }
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },
    
  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData () {
      this.getGraphData()
      Service.elementClone(this.blockId, this.cloneElementId)
    },

    getGraphData() {
      CMS.getGraph(this.userToken, '30,31,32,33,34,35,36').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>